import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@/styles/global.css";
import "@/styles/desktop.css";
import AppRouter from "@/app/AppRouter";
import { prepararSistemaArquivos } from "@/platform/file-system";
import { instalarReescritaDeRede } from "@/platform/rede-url";
import { registrarServiceWorker } from "@/platform/sw-update";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Dev: reescreve as chamadas ao T-ARC (sem CORS) para o proxy do Vite. Ver rede-url.ts.
instalarReescritaDeRede();

// Offline-first: pede armazenamento persistente (o browser não apaga a fila de batidas).
void navigator.storage?.persist?.().catch(() => {});
void prepararSistemaArquivos().catch(() => {});

registrarServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
